/* eslint-disable unicorn/consistent-function-scoping */
import { HttpStatusCode, isAxiosError } from 'axios';
import { appConfig } from 'config';
import { http } from 'services/http';
import { setAccount, setAccountGroups, setAccounts, setUser } from 'store/actions/actions';
import { sanitizeFilters } from 'utils/format';
import { toQueryStringWithArraySupport } from 'utils/url';
const apiUrl = appConfig.api;
export function changeUserInfo(userInfo) {
    return async ({ dispatch, state }) => {
        const data = await http({
            method: 'PUT',
            url: '/user',
            data: userInfo,
            accessToken: state.accessToken
        });
        dispatch(setUser(data.user));
    };
}
export function resendVerification(email) {
    return async ({ state }) => {
        await http({
            method: 'POST',
            url: '/user/resend-verification',
            data: { email },
            accessToken: state.accessToken
        });
    };
}
export function changePassword(passwords) {
    return async ({ state }) => {
        await http({
            method: 'PUT',
            url: '/user/password',
            data: passwords,
            accessToken: state.accessToken
        });
    };
}
export function postUserInvite({ is2FA, isReviewer, isDownloader, accountGroupId, isAccountAdmin, firstName, lastName, email }) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: '/accounts/invites',
            data: {
                email,
                accountGroupId,
                isReviewer,
                isDownloader,
                isAccountAdmin,
                firstName,
                lastName,
                is2FA
            },
            accessToken: state.accessToken
        });
    };
}
export function changeAccount(accountId) {
    return async ({ dispatch, state }) => {
        const data = await http({
            method: 'PUT',
            url: `/accounts/${accountId}`,
            accessToken: state.accessToken
        });
        const { account } = data;
        dispatch(setAccount(account));
        const user = await loadUserInfoIntoStore(state.accessToken, dispatch);
        return {
            user,
            account
        };
    };
}
export function confirmEmail(token) {
    return async ({ dispatch, state }) => {
        const data = await http({
            method: 'post',
            url: '/user/confirm',
            data: {
                token
            },
            accessToken: state.accessToken
        });
        dispatch(setUser(data.user));
        dispatch(setAccount(data.account));
        return data;
    };
}
export function updateAccountInfo(data) {
    return async ({ state }) => {
        return http({
            method: 'put',
            url: `/update-account-info`,
            data: { data },
            accessToken: state.accessToken
        });
    };
}
export function updateAccountTerms(data) {
    return async ({ state }) => {
        return http({
            method: 'put',
            url: `/accounts/terms/accept`,
            data: {
                termsVersion: data.termsVersion,
                setupAccountStep: data.setupAccountStep
            },
            accessToken: state.accessToken
        });
    };
}
export function createAccount(data) {
    return async ({ state }) => {
        return http({
            method: 'post',
            url: `/accounts`,
            data: { data },
            accessToken: state.accessToken
        });
    };
}
export function createAccountGroup({ name, environment }) {
    return async ({ state }) => {
        return http({
            method: 'post',
            url: `/accounts/groups`,
            data: { name, environment },
            accessToken: state.accessToken
        });
    };
}
export function deleteAccountGroup({ accountGroupId }) {
    return async ({ state }) => {
        return http({
            method: 'delete',
            url: `/accounts/groups/${accountGroupId}`,
            accessToken: state.accessToken
        });
    };
}
export function patchUser({ userId, groupId }) {
    return async ({ state }) => {
        return http({
            method: 'patch',
            url: `/user/${userId}`,
            data: { groupId },
            accessToken: state.accessToken
        });
    };
}
export function changeAccountPermissions({ id, permissions: { isAccountAdmin, isDisabled, isReviewer, isDownloader, is2FA } }) {
    return async ({ state }) => {
        return http({
            method: 'put',
            url: `/accounts/users/${id}/permissions`,
            data: {
                isAccountAdmin,
                isDownloader,
                isDisabled,
                isReviewer,
                is2FA
            },
            accessToken: state.accessToken
        });
    };
}
export const getAccount = (accessToken) => {
    return async ({ dispatch }) => {
        const data = await http({
            method: 'GET',
            url: `/account`,
            accessToken
        });
        dispatch(setAccount(data.account));
        return data;
    };
};
const getAccountDirect = async (accessToken) => {
    return http({
        method: 'GET',
        url: `/account`,
        accessToken
    });
};
export function getAccountUsers() {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: '/accounts/users',
            accessToken: state.accessToken
        });
    };
}
export function adminLoadAccount(id) {
    return async ({ state }) => {
        const data = await http({
            method: 'GET',
            url: `/admin/accounts/${id}`,
            accessToken: state.accessToken
        });
        return data.account;
    };
}
export function adminLoadTemplate(id) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            apiService: `${apiUrl}/admin/templates/${id}`,
            accessToken: state.accessToken
        });
    };
}
export function adminUpdateAccount(id, data) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            url: `/admin/accounts/${id}`,
            accessToken: state.accessToken,
            data
        });
    };
}
export function adminUpdateTemplateConfiguration(data) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            apiService: `${apiUrl}/admin/templates/update-template-configuration`,
            accessToken: state.accessToken,
            data
        });
    };
}
export function adminDeleteTemplate(id) {
    return async ({ state }) => {
        return http({
            method: 'DELETE',
            apiService: `${apiUrl}/admin/templates/${id}`,
            accessToken: state.accessToken
        });
    };
}
export function adminReloadTemplates() {
    return async ({ state }) => {
        return http({
            method: 'DELETE',
            apiService: `${apiUrl}/admin/templates`,
            accessToken: state.accessToken
        });
    };
}
export function adminPromoteTemplate(sid) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            apiService: `${apiUrl}/admin/templates/promote-template/${sid}`,
            accessToken: state.accessToken
        });
    };
}
export function adminUpdateUser(data) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            url: `/admin/user/`,
            accessToken: state.accessToken,
            data
        });
    };
}
export function adminRerunJob(sid) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            apiService: `${apiUrl}/admin/rerun-job/${sid}`,
            accessToken: state.accessToken
        });
    };
}
export function loadAccounts() {
    return async ({ dispatch, state }) => {
        const { accounts } = await getAccounts(state.accessToken, null);
        dispatch(setAccounts(accounts));
        return accounts;
    };
}
export async function getAccounts(accessToken, filter = null) {
    const params = filter
        ? toQueryStringWithArraySupport(filter)
        : '';
    return http({
        method: 'GET',
        url: `/accounts?${params}`,
        accessToken
    });
}
export function loadTemplates(filter) {
    return async ({ state }) => {
        let params = '';
        if (filter) {
            params = toQueryStringWithArraySupport(sanitizeFilters(filter));
        }
        if (!params) {
            params = '';
        }
        return http({
            method: 'GET',
            url: `/admin/templates?${params}`,
            accessToken: state.accessToken
        });
    };
}
const loadAccountGroups = async (accessToken) => {
    return http({
        method: 'get',
        url: `/accounts/groups`,
        accessToken
    });
};
const loadUserInfoIntoStore = async (accessToken, dispatch) => {
    const { user, accountGroup } = await http({
        method: 'GET',
        url: '/user/info',
        accessToken
    });
    dispatch(setUser(user));
    if (user.isAccountAdmin) {
        dispatch(setAccountGroups((await loadAccountGroups(accessToken)).accountGroups));
    }
    else {
        dispatch(setAccountGroups(accountGroup ? [accountGroup] : []));
    }
    return user;
};
export function getUserInfo() {
    return async ({ dispatch, state }) => {
        const user = await loadUserInfoIntoStore(state.accessToken, dispatch);
        if (user.accountId) {
            const { account } = await getAccountDirect(state.accessToken);
            if (!account) {
                return;
            }
            dispatch(setAccount(account));
        }
        return user;
    };
}
export function getGeocode(address) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: '/google/geocode',
            data: { address },
            accessToken: state.accessToken
        });
    };
}
export const removeJob = (sid) => {
    return async ({ state }) => {
        await http({
            method: 'DELETE',
            apiService: `${apiUrl}/jobs/${sid}`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
};
export const downloadJob = (sid, confValue) => {
    return async ({ state }) => {
        const params = toQueryStringWithArraySupport({ confidences: confValue });
        return http({
            method: 'GET',
            apiService: `${apiUrl}/jobs/${sid}/download?${params}`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
};
export const retrieveAamvaDetailed = (sid) => {
    return async ({ state }) => {
        return http({
            method: 'GET',
            apiService: `${apiUrl}/jobs/${sid}/aamva`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
};
export const retrieveAmlDetailed = (id) => {
    return async ({ state }) => {
        return http({
            method: 'GET',
            apiService: `${apiUrl}/aml?id=${id}`,
            url: 'url',
            accessToken: state.accessToken
        }).catch((error) => {
            if (isAxiosError(error) &&
                error.response?.status === HttpStatusCode.NotFound) {
                return undefined;
            }
            throw error;
        });
    };
};
export function loadJobs(filters, isAdmin) {
    return async ({ state }) => {
        filters = { ...filters };
        // normalize id type
        if (filters.respIdState) {
            filters.respIdState = filters.respIdState.toUpperCase();
        }
        if (filters.respIdCountry) {
            filters.respIdCountry = filters.respIdCountry.toUpperCase();
        }
        if (filters.respIdType) {
            filters.respIdType = filters.respIdType
                .split(' ')
                .map((m) => m.toLowerCase())
                .join('-');
        }
        const sanitizedFilters = sanitizeFilters(filters);
        const params = toQueryStringWithArraySupport(sanitizedFilters);
        return http({
            method: 'GET',
            apiService: `${apiUrl}${isAdmin ? '/admin' : ''}/jobs?${params}`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
}
export function loadJob(id, isAdmin) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            apiService: `${apiUrl}${isAdmin ? '/admin' : ''}/jobs/${id}?withPhotoUrls=true`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
}
export function updateReviewStatus(body) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            apiService: `${apiUrl}/jobs/${body.id}/review/status`,
            url: 'url',
            accessToken: state.accessToken,
            data: body
        });
    };
}
export function updateReview(id, body) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            apiService: `${apiUrl}/jobs/${id}/review`,
            url: 'url',
            accessToken: state.accessToken,
            data: body ?? undefined
        });
    };
}
export function getSSNJob(id) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            apiService: `${apiUrl}/ecbsv-ssn/jobs/${id}`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
}
export function getPrivateSSNJob(id) {
    return async ({ state }) => http({
        method: 'GET',
        apiService: `${apiUrl}/private-ssn/jobs/${id}`,
        url: 'url',
        accessToken: state.accessToken
    });
}
export function getDobJob(id) {
    return async ({ state }) => http({
        method: 'GET',
        apiService: `${apiUrl}/dob/jobs/${id}`,
        accessToken: state.accessToken
    });
}
export function loadUserInvites() {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: `/accounts/invites`,
            accessToken: state.accessToken
        });
    };
}
export function loadInvites(filters) {
    return async ({ state }) => {
        const params = toQueryStringWithArraySupport(sanitizeFilters(filters));
        return http({
            method: 'GET',
            apiService: `${apiUrl}/invites?${params}`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
}
export function postInvite(invite) {
    return async ({ state }) => {
        if (!invite.send) {
            invite.contact = null;
        }
        invite.internalId ??= null;
        return http({
            method: 'POST',
            apiService: `${apiUrl}/invites`,
            url: 'url',
            accessToken: state.accessToken,
            data: invite
        });
    };
}
export function updateKey(type, accountGroupId, environment = 'live') {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: `/accounts/key`,
            accessToken: state.accessToken,
            data: {
                accountGroupId,
                type,
                environment
            }
        });
    };
}
export function deleteKey(type) {
    return async ({ state }) => {
        return http({
            method: 'DELETE',
            url: `/accounts/key/${type}`,
            accessToken: state.accessToken
        });
    };
}
export function checkKey(key, accountGroupId) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: `/accounts/keycheck`,
            accessToken: state.accessToken,
            data: {
                accountGroupId,
                key
            }
        });
    };
}
export function existKey(type) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: `/accounts/key/${type}`,
            accessToken: state.accessToken
        });
    };
}
export function removeUserInvite(id) {
    return async ({ state }) => {
        return http({
            method: 'DELETE',
            url: `/accounts/invites/${id}`,
            accessToken: state.accessToken
        });
    };
}
export function acceptInvite(token, password) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            url: '/accounts/invites/accept',
            data: { token, password },
            accessToken: state.accessToken
        });
    };
}
export function resendInvite(id) {
    return async ({ state }) => {
        await http({
            method: 'POST',
            apiService: `${apiUrl}/invites/${id}/resend`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
}
export function linkUserInvite(id) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: `/accounts/invites/${id}/link`,
            accessToken: state.accessToken
        });
    };
}
export function resendUserInvite(id) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            url: `/accounts/invites/${id}/resend`,
            accessToken: state.accessToken
        });
    };
}
export function copyInvite(id) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            apiService: `${apiUrl}/invites/${id}/copy`,
            url: 'url',
            accessToken: state.accessToken
        });
    };
}
export function initiateLogin(email) {
    return async () => {
        return http({
            method: 'POST',
            url: '/auth/sso/initiate',
            data: {
                email
            }
        });
    };
}
export function finalizeLogin(accessToken) {
    return async () => {
        return http({
            method: 'POST',
            url: '/auth/sso/finalize',
            accessToken
        });
    };
}
export function login(data) {
    return async () => {
        return http({
            method: 'POST',
            url: '/login',
            data
        });
    };
}
export function twoFactorLogin(data) {
    return async () => {
        return http({
            method: 'POST',
            url: '/verify-2fa',
            data
        });
    };
}
export function forgotPassword(email) {
    return async () => {
        return http({
            method: 'POST',
            url: '/user/reset-password',
            data: { email }
        });
    };
}
export function resetPassword(data) {
    return async () => {
        return http({
            method: 'POST',
            url: '/user/password',
            data
        });
    };
}
export function addPaymentMethod(paymentMethodData) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: '/payments/add_payment_method',
            data: paymentMethodData,
            accessToken: state.accessToken
        });
    };
}
export function deletePaymentMethod(paymentMethodId) {
    return async ({ state }) => {
        return http({
            method: 'DELETE',
            url: '/payments/delete_payment_method',
            data: { paymentMethodId },
            accessToken: state.accessToken
        });
    };
}
export function getPaymentMethods() {
    return async ({ state }) => {
        const paymentMethods = await http({
            method: 'GET',
            url: '/payments/get_payment_methods',
            accessToken: state.accessToken
        });
        return paymentMethods.paymentMethods;
    };
}
export function setPaymentMethodDefault(paymentMethodId) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            url: '/payments/set_payment_method_default',
            data: { paymentMethodId },
            accessToken: state.accessToken
        });
    };
}
export function getCurrentCustomer() {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: '/payments/customer',
            accessToken: state.accessToken
        });
    };
}
export function getSubscriptInvoices() {
    return async ({ state }) => {
        const invoices = await http({
            method: 'GET',
            url: '/payments/get_subscript_invoices',
            accessToken: state.accessToken
        });
        return invoices.invoices;
    };
}
export function cancelSubscription() {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: '/payments/cancel_subscription',
            accessToken: state.accessToken
        });
    };
}
export function adminCreateAccount(data) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: `/admin/accounts`,
            accessToken: state.accessToken,
            data
        });
    };
}
export function getAccountConfigDefaults() {
    return async ({ state }) => {
        return http({
            method: 'GET',
            apiService: `${apiUrl}/admin/config/default`,
            accessToken: state.accessToken
        });
    };
}
export function adminCreateTemplate(data) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            apiService: `${apiUrl}/admin/templates`,
            accessToken: state.accessToken,
            data
        });
    };
}
export function adminCreateTemplateFromBase(data) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            apiService: `${apiUrl}/admin/templates/${data.baseTemplateId}`,
            accessToken: state.accessToken,
            data: {
                country: data.country,
                state: data.state,
                version: data.version,
                type: data.type
            }
        });
    };
}
export function loadUsersBySearch(search) {
    return async ({ state }) => {
        const sanitized = sanitizeFilters(search);
        const params = toQueryStringWithArraySupport(sanitized);
        const data = await http({
            method: 'GET',
            url: `/users/search?${params}`,
            accessToken: state.accessToken
        });
        return data;
    };
}
export function loadUser(id) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: `/admin/user/${id}`,
            accessToken: state.accessToken
        });
    };
}
export function updateAccountProperties(id, data) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            url: `/admin/accounts/${id}/properties`,
            accessToken: state.accessToken,
            data
        });
    };
}
export function loadAccountProperties(id) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: `/admin/accounts/${id}/properties`,
            accessToken: state.accessToken
        });
    };
}
export function adminUsageReport(from, to, accountId = null) {
    return async ({ state }) => {
        const params = toQueryStringWithArraySupport(sanitizeFilters({
            from,
            to,
            accountId
        }));
        return http({
            method: 'GET',
            url: `/payments/usage_report?${params}`,
            accessToken: state.accessToken
        });
    };
}
export function adminDisableAccount(accountId) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: `/admin/accounts/${accountId}/disable`,
            accessToken: state.accessToken
        });
    };
}
export function requestUpgrade(accountId, requestedTier) {
    return async ({ state }) => {
        return http({
            method: 'POST',
            url: `/accounts/${accountId}/request-upgrade`,
            accessToken: state.accessToken,
            data: {
                requestedTier
            }
        });
    };
}
export function isSingleUseSignupTokenAvailable(token) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: `/accounts/single-use-signup-token/${token}`,
            accessToken: state.accessToken
        }).catch(() => {
            return { available: false };
        });
    };
}
export function getAnalyticsEmbedUrl() {
    return async ({ state }) => {
        return http({
            method: 'GET',
            url: '/analytics/embed-url',
            accessToken: state.accessToken
        });
    };
}
export function getTinValidationJob(jobSid) {
    return async ({ state }) => http({
        method: 'GET',
        apiService: `${apiUrl}/tin/jobs/${jobSid}`,
        url: 'url',
        accessToken: state.accessToken
    });
}
export function getAmlV2Job(jobSid) {
    return async ({ state }) => {
        return http({
            method: 'GET',
            apiService: `${apiUrl}/v2/aml/${jobSid}`,
            accessToken: state.accessToken
        });
    };
}
export function loadAdminAccountGroups(accountId) {
    return async ({ state }) => {
        const data = await http({
            method: 'GET',
            url: `/admin/accounts/${accountId}/groups`,
            accessToken: state.accessToken
        });
        return data.accountGroups;
    };
}
export function loadAccountGroupConfigs(accountId) {
    return async ({ state }) => {
        const data = await http({
            method: 'GET',
            url: `/admin/accounts/${accountId}/group-config`,
            accessToken: state.accessToken
        });
        return data.configs;
    };
}
export function updateGroupConfig(accountId, config) {
    return async ({ state }) => {
        const data = await http({
            method: 'PUT',
            url: `/admin/accounts/${accountId}/group-config`,
            data: config,
            accessToken: state.accessToken
        });
        return data.config;
    };
}
export function getSsoConfig(accountId) {
    return async ({ state }) => {
        const data = await http({
            method: 'GET',
            url: `/accounts/${accountId}/sso-config`,
            accessToken: state.accessToken
        });
        return data.ssoConfig;
    };
}
export function putSsoConfig(accountId, config) {
    return async ({ state }) => {
        const data = await http({
            method: 'PUT',
            url: `/accounts/${accountId}/sso-config`,
            data: config,
            accessToken: state.accessToken
        });
        return data.ssoConfig;
    };
}
export function putSsoEnabled(accountId, enabled) {
    return async ({ state }) => {
        return http({
            method: 'PUT',
            url: `/accounts/${accountId}/sso-config/enabled`,
            data: { enabled },
            accessToken: state.accessToken
        });
    };
}
export function putSsoJitDefaults(accountId, defaults) {
    return async ({ state }) => {
        const data = await http({
            method: 'PUT',
            url: `/accounts/${accountId}/sso-config/jit-defaults`,
            data: defaults,
            accessToken: state.accessToken
        });
        return data.ssoConfig;
    };
}
